import authority from './authority';
var path = '/operation';
var operation = function (url) { return function () { return ({
    authority: authority(url + path),
}); }; };
export default operation;
